// extracted by mini-css-extract-plugin
export default {"wrapper":"g3aoAGOQ8LggNedDtsQM","pressed":"atFyhZRYv5GaBQzFPVSV","disabled":"rou7leoSoNGyzMMgneou","small":"eH4SLNLIHDruay9rKiJg"};